import { QueryResult, useQuery } from "@apollo/client";
import { orderBy } from "lodash";
import { GET_COMPANIES } from "graphql/queries";
import { Company } from "types";

export type CompanyResult = {
    companies: Company[];
};

export function useCompanies(): [Company[], QueryResult<CompanyResult>] {
    const queryData = useQuery<CompanyResult>(GET_COMPANIES, {
        errorPolicy: "all"
    });
    const { data } = queryData;
    return [data ? orderBy(data.companies, (c: Company) => c.name) : [], queryData];
}
